module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-01-31 100923.ff539b19.png";